import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL, getMediaURL } from '../config';

const ServiceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchService = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/api/services?filters[documentId][$eq]=${id}&populate=*`);
        console.log('Service Detail Response:', response.data);
        
        if (!response.data?.data?.[0]) {
          throw new Error('Service not found');
        }

        const serviceData = response.data.data[0];
        console.log('Service Data:', serviceData);
        
        setService({
          id: serviceData.documentId,
          title: serviceData.title || '',
          description: serviceData.description || '',
          content: serviceData.content || '',
          image: serviceData.image?.formats?.large?.url 
            ? getMediaURL(serviceData.image.formats.large.url) 
            : null
        });
      } catch (error) {
        console.error('Error fetching service:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchService();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 pt-20">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !service) {
    return (
      <div className="min-h-screen bg-gray-100 pt-20">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Hata
            </h1>
            <p className="text-gray-600">
              {error || 'Hizmet bulunamadı.'}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with Image and Title */}
      <div className="relative h-[60vh] w-full">
        {service.image ? (
          <>
            <img
              src={service.image}
              alt={service.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          </>
        ) : (
          <div className="w-full h-full bg-gray-900"></div>
        )}
        
        {/* Title Overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center px-4 max-w-4xl">
            {service.title}
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto py-12">
          {service.description && (
            <p className="text-xl text-gray-600 mb-12 leading-relaxed">
              {service.description}
            </p>
          )}
          
          <div className="prose prose-lg max-w-none">
            <div 
              dangerouslySetInnerHTML={{ __html: service.content }}
              className="prose-headings:text-gray-900 prose-headings:font-bold prose-p:text-gray-600 prose-p:leading-relaxed prose-a:text-primary hover:prose-a:text-primary-dark prose-strong:text-gray-900"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
